<div class="header">
  <div class="header__up">
    <div class="header__left">
      <div class="img-plc g-cursor-pointer" routerLink="/">
        <img alt="" src="{{logo}}"/>
      </div>
    </div>
    <div class="header__right">
      <button (click)="myNotifications()"
              class="bell-button"
              mat-button>
        <img src="{{bell}}"
             class="notification-bell">
        <span class="badge" *ngIf="notificationCount > 0">
                <span>{{notificationCount}}</span>
              </span>
      </button>

      <div class="divider-line"></div>


      <div class="user-name">
        <p>{{user?.name || (user?.firstName + ' ' + user?.lastName)}}</p>
      </div>
      <div>
        <button [matMenuTriggerFor]="menu" [ngStyle]="{'background-image':'url(' + avatar + ')'}"
                class="avatar"
                mat-button></button>
        <mat-menu #menu="matMenu">
          <button (click)="myProfile()" class="dropdown-my-profile" mat-menu-item>My profile</button>
          <button mat-menu-item routerLink="{{logoutPath}}">Log out</button>
        </mat-menu>
      </div>

    </div>
  </div>

  <div class="header__bottom">
    <div *appPermissions="userPermission" class="link">
      <a *appPermissions="userPermission" routerLink="{{usersLink}}" routerLinkActive="active-link">Account Settings</a>
    </div>
    <div *appPermissions="applicationListPermission + ',' + applicationCustomReadListPermission" class="link">
      <a routerLink="{{applicationList}}" routerLinkActive="active-link">Applications</a>
    </div>
    <div *appPermissions="facilityListPermission" class="link">
      <a routerLink="{{facilityInformationLink}}" routerLinkActive="active-link">Facility Information</a>
    </div>
    <div *appPermissions="surveyPermission" class="link">
      <a routerLink="{{surveyLink}}" routerLinkActive="active-link">Survey</a>
    </div>
    <div *appPermissions="accreditationPermission" class="link">
      <a routerLink="{{accreditationLink}}" routerLinkActive="active-link">Accreditation Cycle</a>
    </div>
    <div *appPermissions="invoicePermission + ',' + paymentPermission + ',' + orderPermission" class="link">
      <a routerLink="{{customerLink}}" routerLinkActive="active-link">Finances</a>
    </div>
    <div *appPermissions="investigationPermission" class="link">
      <a routerLink="{{investigationLink}}" routerLinkActive="active-link">Investigation</a>
    </div>
    <div *appPermissions="externalReportsPermission" class="link">
      <a routerLinkActive="active-link" routerLink="{{externalReportsLink}}">Reports</a>
    </div>
    <div *appPermissions="historyPermission" class="link">
      <a routerLinkActive="active-link" routerLink="/history">History</a>
    </div>
    <div class="link">
      <a routerLinkActive="active-link" routerLink="/notifications/list">Notifications</a>
    </div>

    <div *appPermissions="qboPermission" class="link">
      <a (click)="connectToQbo()" *ngIf="!qboConnected" routerLinkActive="active-link">Connect to Quickbooks</a>
    </div>
  </div>
</div>
